import type { ChartOptions } from "chart.js";
import { ChartData } from "chart.js";

function configs(labels: string[], datasets: any[]): {
  data: ChartData<"radar">;
  options: ChartOptions<"radar">;
} {
  return {
    data: {
      labels,
      datasets,
    },
    options: {
      responsive: false,
      maintainAspectRatio: false,
      scales: {
        r: {
          angleLines: { display: true },
          suggestedMin: 0,
          suggestedMax: 100,
          pointLabels: {
            font: {
              size: 12,
            },
          },
          ticks: {
            stepSize: 20,
            backdropColor: "transparent",
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          display: false, // ← 値を非表示にする
        },
      },
    },
  };
}

export default configs;
